import fetchPonyfill from 'fetch-ponyfill';
import { get, omit, has } from 'lodash';
import qs from 'query-string';
import store from '../store';
import settings from '../config/settings';
import { getPlatform, getOAuthApplicationId } from './mobile';

const { fetch } = fetchPonyfill();

export const parseOAuthToken = () => {
  const qsResult = window.location.hash.slice(1);
  const parsedToken = qs.parse(qsResult);

  if (has(parsedToken, 'access_token')) {
    localStorage.setItem('oauth_token', JSON.stringify({ oauth: parsedToken }));
    return parsedToken;
  }

  return null;
};

const getAuthUrl = () => {
  const platform = getPlatform();
  const clientId = getOAuthApplicationId() || get(settings, `client_id.${platform}`);

  const payload = {
    client_id: clientId,
    response_type: settings.response_type,
    redirect_uri: window.location.origin,
  };

  return `${settings.oauth_url}?${qs.stringify(payload)}`;
};

// Due to bug in IOS, we need to redirect on a next tick
const redirect = url =>
  new Promise(resolve => setTimeout(resolve, 0))
    .then(() => { window.location.href = url; });

export const logout = () => {
  const payload = {
    next: getAuthUrl(),
  };

  const href = `${settings.account_url}${settings.logout_url}?${qs.stringify(payload)}`;

  return redirect(href);
};

export const refreshOAuthToken = () =>
  redirect(`${settings.account_url}${getAuthUrl()}`);

const checkIsTokenValid = resp => (resp.status === 401 ? refreshOAuthToken() : resp);

export default function (url, init = {}) {
  const {
    session: { accessToken },
  } = store.getState();

  if (!accessToken) {
    throw new Error('Invalid token provided.');
  }

  const apiPath = settings.gems_url;
  const headers = get(init, 'headers', {});

  const options = {
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`,
    },
    ...omit(init, ['headers']),
  };

  const isAbsolute = url.indexOf('http') === 0;
  const path = isAbsolute ? url : `${apiPath}${url}`;

  return fetch(path, options)
    .then(checkIsTokenValid);
}

export const dedeshify = id => id.replace(/-/g, '');



// WEBPACK FOOTER //
// ./src/utils/api.js